import { MapMarkerIcon } from './MapMarkerIcon';

/**
 * author: Google
 * id 379B9D93-434B-46E7-9ABC-CAFAB694B209
 * name map-marker
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationOnIcon = MapMarkerIcon;
export default LocationOnIcon